module.exports = __webpack_public_path__ + "img/5.29dd529a.jpg";